import { render, staticRenderFns } from "./ServiceAlertDistribution.vue?vue&type=template&id=aea84864&scoped=true&"
import script from "./ServiceAlertDistribution.vue?vue&type=script&lang=js&"
export * from "./ServiceAlertDistribution.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAlertDistribution.vue?vue&type=style&index=0&id=aea84864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea84864",
  null
  
)

export default component.exports